class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M.997 1H6v1H.997V1ZM5 3H1v1h4V3Z"></path><path fill-rule="evenodd" d="M10.76 11.304a.998.998 0 0 1 .705-.292h1.994a.998.998 0 0 1 .997.997v1.994a.998.998 0 0 1-.997.997h-1.994a.998.998 0 0 1-.997-.997v-1.994c0-.264.106-.518.293-.705Zm2.7 2.699v-1.994h-1.995v1.994h1.994Z" clip-rule="evenodd"></path><path d="M2.493 7.908.705 9.696 0 8.99 2.991 6l2.991 2.991-.705.705L3.49 7.908v2.578c0 1.102.893 1.994 1.995 1.994h2.99v.997h-2.99a2.991 2.991 0 0 1-2.991-2.99v-2.58Zm12.802-2.104-1.788 1.788V5.013a2.991 2.991 0 0 0-2.99-2.99H7.524v.996h2.991c1.102 0 1.994.893 1.994 1.994v2.579l-1.787-1.788-.705.705 2.99 2.991L16 6.509l-.705-.705Z"></path></svg>';
  }
}
const e = "pi-info-exchange";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
